import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnDestroy,
  AfterContentChecked,
  ElementRef,
  HostListener,
} from "@angular/core";
import { CommonService } from "src/app/services/common.service";
import { AskApolloService } from "src/app/services/ask-apollo.service";
import { LeadsService } from "src/app/services/leads.service";
import { ContactsService } from "src/app/services/contacts.service";
import { CallCenterService } from "src/app/services/call-center.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  CallCenterAddCallInBoundDetails,
  CallCenterAddCallOutBoundDetails,
} from "src/app/models/call-center.model";
import { Speciality } from "src/app/models/common-model";
import { Subject, Subscription } from "rxjs";
import { MessageServiceService } from "src/app/services/message-service.service";
import * as signalR from "@aspnet/signalr";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-call-center-inbound-call",
  templateUrl: "./call-center-inbound-call.component.html",
  styleUrls: ["./call-center-inbound-call.component.scss"],
})
export class CallCenterInboundCallComponent
  implements OnInit, OnDestroy, AfterContentChecked
{
  clickEventsubscription: Subscription;
  callInboundOrOutbound$: Subscription;
  UHIDonMobileorEmail$: Subscription;
  //tab flags
  UHIDFullDetailsTab: boolean = false;
  UHIDsListTab: boolean = true;

  displayPosition: boolean;
  position: string = "bottomright";

  display: boolean = false;
  leadSourceDataDisplay: boolean = true;
  leadSourceData: string = "";
  currentMobileNumber: string = "";
  currentEmailId: string = "";
  searchInputOnPhoneNo: string = "";
  selectedUHID: any;
  proceedFlag: boolean = false;
  isCallStarted: boolean = false;
  callerStatusAutoId = 0;
  isInboundNewUser: boolean = false;
  createNewUserForm: FormGroup;
  selectedTriggerInboundCall$: Subscription;
  getClickEvent$: Subscription;
  callerId: any;
  createNewUserMessage: string;
  isDefault: boolean;
  createNewUserForm1: FormGroup;
  isInboundNewUser1: boolean = false;
  private hubConnectionForCreateUser: signalR.HubConnection;

  booleanValue: boolean = false;
  private booleanSubscription: Subscription;
  searchHistory1: any[] = [];
  formattedSearchResults: string;
  selectedUser: any;
  callervsble: boolean = false;
  selectedTable: string = ""; // Default selected table
  searchResults1: any[] = [];
  isDefault1: boolean = false;

  constructor(
    private commonService: CommonService,
    private askApolloService: AskApolloService,
    private formBuilder: FormBuilder,
    private contactsService: ContactsService,
    private callCenterService: CallCenterService,
    private messageService: MessageServiceService,
    private leadsService: LeadsService,
    private ref: ChangeDetectorRef,
    private http: HttpClient,
    private datepipe: DatePipe
  ) {
    this.getClickEvent$ = this.commonService
      .getClickEvent()
      .subscribe((eventType) => {
        if (eventType === "OUTBOUND") {
          this.showDialog("OUTBOUND");
          this.isCallStarted = true;
        } else {
          this.showDialog("INBOUND");
          this.isCallStarted = true;
        }
        this.isCallStarted = true;
      });
  }

  flag = false;
  ngAfterViewInit() {
    this.selectedTriggerInboundCall$ =
      this.callCenterService.selectedTriggerInboundCall.subscribe((value) => {
        // console.log("CRM Inbound Event : ", value);
        if (
          this.flag &&
          value &&
          value.patientMobileNumber != "" &&
          value.patientMobileNumber.length > 5
        ) {
          if (value.crmNumber) {
            this.showDialog("OUTBOUND", true, value);
          } else {
            this.showDialog("INBOUND");
          }
        } else {
          this.flag = true;
        }
      });
  }
  isCompactView: boolean = false; // Flag to switch view dynamically

  ngOnInit() {
    this.booleanSubscription = this.commonService.booleanValue$.subscribe(
      (value) => {
        this.booleanValue = value; // Update the value
        //this.isCallCenterPerson =false;
        //this.display = true;
        this.callTypeName = "";
        this.isCallStarted = false;
        this.UHIDList = [];
        this.UHIDFullDetailsTab = false;
        this.createNewUserMessage = "";
        this.isInboundNewUser1 = false;
        this.UHIDsListTab = true;
        this.currentMobileNumber = "";
      }
    );
    //this.isDefault=true;
    this.checkScreenSize();

    this.getLoginUser_CurrentPrivileges();
    this.getAllCountryCodes();
    this.getAllSpecialities();
    this.getSearchHistory();
    this.createNewUserForm = this.formBuilder.group({
      name: ["", [Validators.required]],
      email: [""],
      mobileNo: ["", [Validators.required]],
      countryCode: ["", [Validators.required]],
      speciality: ["", [Validators.required]],
      IsDiagnostics: ["", [Validators.required]],
    });
    this.createNewUserForm1 = this.formBuilder.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      email: [""],
      mobileNo: ["", [Validators.required]],
      countryCode: ["", [Validators.required]],
      speciality: ["", Validators.required],
      //isActive: ["", [Validators.required]],
      //roleId:[""]
    });
    let currentUser: any = JSON.parse(localStorage.getItem("LOGGED_USER_INFO"));
    if (currentUser.bussinessUnitName != "Diagnostics") {
      this.createNewUserForm.get("IsDiagnostics").disable();
    } else {
      this.createNewUserForm.get("speciality").disable();
    }

    this.isDefault = true;
  }

  ngAfterContentChecked(): void {
    this.ref.detectChanges();
  }

  ngOnDestroy(): void {
    this.getClickEvent$.unsubscribe();
    this.selectedTriggerInboundCall$.unsubscribe();
    if (this.booleanSubscription) {
      this.booleanSubscription.unsubscribe();
    }
  }

  isCallCenterPerson: boolean = true;
  public getLoginUser_CurrentPrivileges() {
    let currentUser: any = JSON.parse(localStorage.getItem("LOGGED_USER_INFO"));
    if (
      currentUser.roleName == "Call Center Manager" ||
      currentUser.roleName == "Admin" ||
      currentUser.roleName == "Call Center Agent" ||
      currentUser.roleName == "Super Admin"
    ) {
      this.isCallCenterPerson = true;
    }
  }

  selectUHID(uhidObj) {
    // alert('');
    debugger;
    localStorage.setItem("SelectedUHIDNumber",uhidObj.uhidNumber);
    if (uhidObj == "NEW" && this.callTypeId == 0) {
      this.isInboundNewUser = false;
      this.UHIDsListTab = false;
      this.getAllCountryCodes();
      this.getAllSpecialities();
    } else {
      let isNew = false;
      if (uhidObj == "NEW") {
        isNew = true;
        this.selectedUHID = this.currentCallDetailsObject;
      } else {
        isNew = false;
        //   let tempData = {
        //     ContactName: uhidObj.firstName,
        //     SpecalityId: 0,
        //     EmailId: uhidObj.emailId,
        //     CountryCode: "+91",
        //     MobileNo: uhidObj.mobileNumber,
        //  //   IsDiagnostics: this.f.IsDiagnostics.value,
        //     IsFrom: 1, // where it is created from 1 means inbound call
        //     CallLogId: this.callerStatusAutoId,
        //   };
        let tempData = {
          ContactName: uhidObj.firstName.toString(),
          specalityId: 0,
          emailId: uhidObj.emailId,
          countryCode: "+91",
          mobileNo: uhidObj.mobileNumber,
          isFrom: 1,
          callLogId: this.callerStatusAutoId ? this.callerStatusAutoId : 0,
        };
        this.contactsService.createContact(tempData).subscribe(
          (res) => {
            console.log("Contact Created");
            //this.isInboundNewUser = false;
          },
          (error) => {
            // this.isSubmitted = false;
            this.messageService.showErrorMessage(
              "Unable to add contact, An error occur while adding contact."
            );
          }
        );
        this.selectedUHID = uhidObj;
      }
      this.UHIDsListTab = false;
      this.isInboundNewUser = false;
      this.UHIDFullDetailsTab = true;
      debugger;

      this.callCenterService.ProceedToUHIDList({
        IsNewUser: isNew,
        CallerMobileNumber: this.currentMobileNumber,
        LeadId: this.currentCallDetailsObject["leadId"],
        CallTypeId: this.callTypeId,
        CallerStatusAutoId: this.callerStatusAutoId,
        CallerId: this.callerId,
        UHIDDetails: this.selectedUHID,
      });
    }
  }

  selectedLeadSource: any;
  selectedLeadSourceID = 1;
  selectLeadSource(leadSource) {
    this.selectLeadSource = leadSource;
  }

  backToUHIDListTab() {
    this.UHIDsListTab = true;
    this.UHIDFullDetailsTab = false;
    this.isInboundNewUser = false;
    this.isInboundNewUser1 = false;
    this.isDefault = true;
    this.UHIDListOnSearch1 = false;
    this.createNewUserMessage = "";
    //this.UHIDList =false;
  }

  showDialog(callType, isFromDialer = false, dataFromDialer = null) {
    if (callType == "INBOUND" || callType == "OUTBOUND") {
      this.isCallStarted = true;
      this.OpenPopup(callType, isFromDialer, dataFromDialer);
      this.searchInputOnPhoneNo = "";
      this.UHIDListOnSearch = [];
    } else {
      debugger;
      this.display = true;
      this.callTypeName = "";
      this.isCallStarted = false;
      this.UHIDList = [];
      this.UHIDFullDetailsTab = false;
      this.createNewUserMessage = "";
      this.isInboundNewUser1 = false;

      this.UHIDsListTab = true;

      this.currentMobileNumber = "";
    }
  }

  callTypeName: string = "";
  callTypeId: number;
  currentCallDetailsObject = {};
  //display the call details popup for both out/in bound call
  OpenPopup(callType, isFromDialer, dataFromDialer) {
    this.resetPopupData();
    let leadId: string = "";
    let callLogId: string = "";
    if (callType == "INBOUND") {
      this.callTypeName = "Inbound Call";
      this.callTypeId = 1;
      debugger;
      this.currentCallDetailsObject = JSON.parse(
        localStorage.getItem("CurrentInBoundCallDetails")
      );
    } else if (callType == "OUTBOUND") {
      this.callTypeName = "Outbound Call";
      this.callTypeId = 2;
      if (isFromDialer) {
        //API CALL TO GET LEAD INFORMATION FROM CRM NUMBER
        // let dataArray: any[] = dataFromDialer.crmNumber.toString().split("|");
        // if (dataArray.length == 2) {
        // leadId = dataArray[0];
        // callLogId = dataArray[1];
        this.leadsService
          .getAllLeadsAndAppointmentsOnCallLogId(dataFromDialer.crmNumber)
          .subscribe((res: any) => {
            localStorage.setItem(
              "CurrentOutBoundCallMobileNumber",
              JSON.stringify(res.response.leadAndAppointmentData[0])
            );
            this.currentCallDetailsObject =
              res.response.leadAndAppointmentData[0];
          });
        this.currentCallDetailsObject = {
          phoneNo: dataFromDialer.patientMobileNumber,
        };
        // }
      } else {
        this.currentCallDetailsObject = JSON.parse(
          localStorage.getItem("CurrentOutBoundCallMobileNumber")
        );
      }
    }
    this.display = true;
    this.isLoading = true;
    this.currentMobileNumber =
      callType == "OUTBOUND"
        ? this.currentCallDetailsObject["phoneNo"] == undefined
          ? this.currentCallDetailsObject["mobile"]
          : this.currentCallDetailsObject["phoneNo"]
        : this.currentCallDetailsObject["patientMobileNumber"];
    //this.leadSourceData = this.currentCallDetailsObject["patientMobileNumber"] == "2268668005" ? "BTL" : this.currentCallDetailsObject["patientMobileNumber"] == "2268668006" ? "SEO" : "";
    this.leadSourceData = null;
    let email =
      callType == "OUTBOUND"
        ? this.currentCallDetailsObject["emailId"]
        : "test@mail.com";
    this.currentEmailId = email;
    // if (this.isCountryCodeExists(this.currentMobileNumber)) {
    //   this.currentMobileNumber = this.currentMobileNumber.replace(/^\+?\d{1,4}/, '');
    // }
    let temp = {
      mobile: this.currentMobileNumber.replace("+91", ""),
      email: this.currentEmailId,
    };
    this.getUHIDonMobileorEmail(temp);
    this.addInOrOutBoundCallDetails(
      isFromDialer,
      dataFromDialer && dataFromDialer.crmNumber
        ? dataFromDialer.crmNumber
        : null
    );
  }
  displayChatPopup: boolean = false; // Controls visibility of the popup
  displayChatPopup1: boolean = false; // Controls visibility of the popup

  chatMessage: string = ""; // Stores the message typed by the user
  dummyData: string[] = []; // Array to store dummy data items

  // Opens the popup

  isCountryCodeExists(phoneNumber: string): boolean {
    // Regular expression to check for a country code (e.g. +123, +1, +12, etc.)
    const countryCodePattern = /^\+?\d{1,4}/;

    // Check if the phone number starts with a country code
    return countryCodePattern.test(phoneNumber);
  }

  // Dummy function to handle message sending
  sendChatMessage() {
    if (this.chatMessage.trim()) {
      console.log("Message Sent:", this.chatMessage);
      // Here, you can process the message (e.g., call an API)
      this.chatMessage = ""; // Clear the message input after sending
    } else {
      alert("Please type a message");
    }
  }
  openGenAI() {
    this.displayChatPopup = true;
  }
  userId = localStorage.getItem("LOGGED_USER_CRMID")
    ? Number(localStorage.getItem("LOGGED_USER_CRMID"))
    : -1;

  getSearchHistory() {
    this.askApolloService.GetAiHistory().subscribe(
      (response) => {
        if (response.isSuccess && response.response) {
          this.searchHistory1 = response.response.sort(
            (a, b) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
          console.log("Sorted Search History:", this.searchHistory1);
        }
      },
      (error) => {
        console.error("Error fetching search history:", error);
      }
    );
  }

  isSidebarOpen: boolean = false;
  expandedIndex: number | null = null;

  // Toggle Sidebar
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
  toggleExpand(index: number) {
    if (this.expandedIndex === index) {
      this.expandedIndex = null; // Collapse if already expanded
    } else {
      this.expandedIndex = index;
    }
    this.isSidebarOpen = false;
  }

  //searchResults: string[] = []; // Store API response

  // Dummy function to simulate search and show dummy data
  searchHistory: { query: string; result: string[] }[] = []; // Store last 5 searches
  searchResults: string[] = []; // Current search results
  // allowedTopics: string[] = ['leads', 'doctors', 'activities', 'sales', 'reports', 'invoices']; // Define CRM topics

  searchChatMessage() {
    this.isLoading = true;
    this.searchResults = [];

    if (this.chatMessage.trim()) {
      if (this.selectedTable) {
        // If a table is selected, call searchGenAI1
        const payload = {
          table: this.selectedTable, // Table selected from radio button
          question: this.chatMessage,
        };
        this.callCenterService.searchGenAI1(payload).subscribe(
          (res) => {
            this.isLoading = false;
            debugger;
            if (res && res.result) {
              if (Array.isArray(res.result)) {
                // If result is an array, format dynamically
                this.searchResults = res.result
                  .map((item, index) => {
                    // Remove rawData from the item
                    const { RawData, ...itemWithoutRawData } = item;

                    return `
                            <p><strong>${index + 1}. </strong></p>
                            <ul>
                                ${this.formatDynamicData(itemWithoutRawData)}
                            </ul>
                            <br>
                        `;
                  })
                  .join("");

                this.formattedSearchResults = this.searchResults.toString();
                if (this.formattedSearchResults === "") {
                  this.formattedSearchResults = "No data available.";
                }
              } else if (this.formattedSearchResults.length == 0) {
                this.formattedSearchResults = res.result.replace(/\n/g, "<br>");
              } else if (typeof res.result === "string") {
                this.formattedSearchResults = res.result.replace(/\n/g, "<br>");
              } else {
                this.formattedSearchResults = `<pre>${JSON.stringify(
                  res.result,
                  null,
                  2
                )}</pre>`;
              }
            } else {
              this.formattedSearchResults = "No data available.";
            }
          },
          (error) => {
            console.error("Error fetching data:", error);
            this.formattedSearchResults = "Error fetching data.";
            this.isLoading = false;
          }
        );
      } else {
        // If no table is selected, call searchGenAI
        const payload = { query: this.chatMessage };

        this.callCenterService.searchGenAI(payload).subscribe(
          (res) => {
            this.searchResults = res.answer
              ? res.answer.split("\n").map((line) => line.trim())
              : [];
            this.formattedSearchResults = this.searchResults.join("<br>");
            this.isLoading = false;

            // Store the search history
            this.saveSearchHistory();
          },
          (error) => {
            console.error("Error fetching searchGenAI results:", error);
            this.isLoading = false;
          }
        );
      }
    }
  }
  formatDynamicData(data: any): string {
    return Object.keys(data)
      .map((key) => {
        let formattedValue = this.formatValue(data[key], key);
        return `<li><strong>${this.formatKey(
          key
        )}:</strong> ${formattedValue}</li>`;
      })
      .join("");
  }

  formatValue(value: any, key: string): string {
    if (value === null || value === undefined || value === "null") {
      return "Not Available";
    }
    if (typeof value === "string" && key.toLowerCase().includes("date")) {
      return this.formatDate(value);
    }
    if (typeof value === "string" && key.toLowerCase().includes("phone")) {
      return this.formatPhone(value);
    }
    if (typeof value === "number" && key.toLowerCase().includes("gender")) {
      return this.formatGender(value);
    }
    return value.toString();
  }

  formatKey(key: string): string {
    return key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());
  }

  formatDate(dateString: string): string {
    // Check if the dateString is a valid date
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid Date"; // Return a fallback message if the date is invalid
    }
    return date.toISOString().replace("T", " ").split(".")[0] + "+00:00";
  }

  formatPhone(phone: string): string {
    return phone ? phone : "Not Available";
  }

  formatGender(gender: number): string {
    return gender === 0 ? "Male" : gender === 1 ? "Female" : "Not Specified";
  }
  @HostListener("window:resize", [])
  onResize() {
    this.checkScreenSize();
  }
  checkScreenSize() {
    const screenWidth = window.innerWidth;

    if (this.isMinimized || screenWidth < 900) {
      this.isCompactView = true; // Show dropdown
    } else {
      this.isCompactView = false; // Show radio buttons
    }
  }

  saveSearchHistory() {
    // Store only the last 5 searches
    if (this.searchHistory.length > 5) {
      this.searchHistory.pop();
    }

    const historyPayload = {
      UserId: localStorage.getItem("LOGGED_USER_CRMID")
        ? Number(localStorage.getItem("LOGGED_USER_CRMID"))
        : -1,
      SearchQuery: this.chatMessage,
      SearchResult: this.searchResults.join(" "),
    };

    this.askApolloService.AddAIHistory(historyPayload).subscribe(
      (response) => {
        console.log("Search history stored successfully", response);
        this.getSearchHistory();
      },
      (error) => {
        console.error("Error storing search history:", error);
      }
    );

    this.chatMessage = ""; // Clear input field
  }

  // isValidQuery(query: string): boolean {
  //   return this.allowedTopics.some(topic => query.toLowerCase().includes(topic));
  // }

  convertToIST(utcTime: string): string {
    // Convert UTC time to IST (UTC + 5:30)
    let utcDate = new Date(utcTime);
    let istTime = new Date(utcDate.getTime() + (5 * 60 + 30) * 60000); // Add 5 hours 30 minutes
    return this.datepipe.transform(istTime, "yyyy-MM-dd HH:mm:ss")!;
  }

  // Closes the popup
  closePopup() {
    this.displayChatPopup = false;
    this.displayChatPopup1 = false;

    this.searchResults = [];
    this.chatMessage = ""; // Clear the message input after sending
  }

  addOutBoundCallDetails: CallCenterAddCallOutBoundDetails;
  addInBoundCallDetails: CallCenterAddCallInBoundDetails;
  addInOrOutBoundCallDetails(isFromDialer, callLogId) {
    if (this.callTypeId == 2) {
      this.addOutBoundCallDetails = {
        CallerId:
          this.currentCallDetailsObject["statusId"] == 29
            ? this.currentCallDetailsObject["callerUniqueId"]
            : this.makeCallerId(10),
        Mobile: this.currentMobileNumber,
        CountryCode: 91,
        LeadId: this.currentCallDetailsObject["leadId"]
          ? this.currentCallDetailsObject["leadId"]
          : 0,
        IsActivityLead:
          localStorage.getItem("IsActivityLead") == "true" ? true : false,
        BusinessUnit: this.currentCallDetailsObject["businessUnit"]
          ? this.currentCallDetailsObject["businessUnit"]
          : "",
        PatientName:
          this.currentCallDetailsObject["firstName"] &&
          this.currentCallDetailsObject["lastName"]
            ? this.currentCallDetailsObject["firstName"] +
              " " +
              this.currentCallDetailsObject["lastName"]
            : "",
        CallType: 2,
        CreatedBy: 1,
        CreatedIp: "123.123.25.1",
        IsCallSentToDialer: false,
        DidNumber: 1,
        DialerNumber: "123456",
        LeadSource: "string",
      };
    } else if (this.callTypeId == 1) {
      this.addInBoundCallDetails = {
        CallerId:
          this.currentCallDetailsObject["statusId"] == 29
            ? this.currentCallDetailsObject["callerUniqueId"]
            : this.makeCallerId(10),
        Mobile: this.currentMobileNumber,
        LeadSource: this.leadSourceData,
        CountryCode: 91,
        LeadId: this.currentCallDetailsObject["leadId"]
          ? this.currentCallDetailsObject["leadId"]
          : 0,
        IsActivityLead:
          localStorage.getItem("IsActivityLead") == "true" ? true : false,
        BusinessUnit: this.currentCallDetailsObject["businessUnit"]
          ? this.currentCallDetailsObject["businessUnit"]
          : "",
        PatientName:
          this.currentCallDetailsObject["firstName"] &&
          this.currentCallDetailsObject["lastName"]
            ? this.currentCallDetailsObject["firstName"] +
              " " +
              this.currentCallDetailsObject["lastName"]
            : "",
        DidNumber: this.currentCallDetailsObject["didNumber"]
          ? this.currentCallDetailsObject["didNumber"]
          : "",
        DialerNumber: this.currentCallDetailsObject["patientMobileNumber"]
          ? this.currentCallDetailsObject["patientMobileNumber"]
          : "",
      };
    }

    if (isFromDialer) {
      this.callerStatusAutoId = callLogId;
    } else {
      if (this.callTypeId == 2) {
        //this.callerId = this.addOutBoundCallDetails.CallerId;
        this.callCenterService
          .AddOutBoundCallDetails(this.addOutBoundCallDetails)
          .subscribe((res: any) => {
            this.callerStatusAutoId = res.response ? res.response["key"] : "";
          });
      } else if (this.callTypeId == 1) {
        //  console.log("data",this.addInBoundCallDetails.CallerId);
        this.callerId = this.addInBoundCallDetails.CallerId;
        //  console.log(this.callerId,"CallerID")
        this.callCenterService
          .AddInBoundCallDetails(this.addInBoundCallDetails)
          .subscribe((res: any) => {
            this.callerStatusAutoId = res.response ? res.response["key"] : "";
          });
      }
    }
  }

  UHIDList: any = [];
  isLoading: boolean = false;
  getUHIDonMobileorEmail(payload) {
    this.askApolloService.getUHIDonMobileorEmail(payload).subscribe(
      (res: any) => {
        this.callervsble = true;
        localStorage.removeItem("AppointmentInformation");

        if (res.response.length > 0) {
          debugger;
          this.UHIDList = res.response;
          this.isInboundNewUser1 = false;
          this.createNewUserMessage = "";

          //alert('kk');
          //this.getAllLeadSources();
        } else {
          this.UHIDList = [];
          this.isInboundNewUser1 = true;
          if (this.callTypeId == 2) {
            var leadId = this.currentCallDetailsObject["leadId"];
            this.createNewUserForm1.setValue({
              firstName: this.currentCallDetailsObject["firstName"],
              lastName: this.currentCallDetailsObject["lastName"],
              email: this.currentCallDetailsObject["emailId"],
              mobileNo: this.currentCallDetailsObject["phoneNo"],
              countryCode: this.currentCallDetailsObject["countryCode"],
              speciality: this.currentCallDetailsObject["specalityId"],
            });
          }

          this.createNewUserMessage = "No user found, please create a new user";

          //this.getAllLeadSources();
        }
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        this.messageService.showErrorMessage(
          "Unable to retrieve UHIDs data from server "
        );
      }
    );
  }
  leadSources: any = [];
  getAllLeadSources() {
    this.commonService.getAllLeadSources().subscribe(
      (res: any) => {
        // console.log(res);
        if (res.response.length > 0) {
          this.leadSources = res.response;
        } else {
          this.leadSources = [];
        }
        this.isLoading = false;
        this.selectedLeadSourceID = 1;
      },
      (error) => {
        this.isLoading = false;
        this.messageService.showErrorMessage(
          "Unable to retrieve leadsource data from server "
        );
      }
    );
  }

  resetPopupData() {
    this.UHIDList = [];
    this.selectedUHID = {};
    this.currentCallDetailsObject = {};
    //popup flag
    this.UHIDsListTab = true;
    this.isInboundNewUser1 = false;
    this.UHIDFullDetailsTab = false;
  }

  get f() {
    return this.createNewUserForm.controls;
  }
  get f1() {
    return this.createNewUserForm1.controls;
  }

  isSubmitted = false;

  // Create New contact function
  CreateNewUser(formData) {
    this.isSubmitted = true;
    if (this.createNewUserForm.invalid) {
      this.messageService.showErrorMessage("Please fill in the details..!");
      return;
    }

    let tempData = {
      contactName: this.f.name.value,
      specalityId: Number(this.f.speciality.value),
      emailId: this.f.email.value,
      countryCode: this.f.countryCode.value,
      mobileNo: this.f.mobileNo.value + "",
      isDiagnostics: this.f.IsDiagnostics.value,
      isFrom: 1, // "1" indicates inbound call
      callLogId: this.callerStatusAutoId,
    };

    this.contactsService.createContact(tempData).subscribe(
      (res) => {
        // alert('km');
        debugger;
        this.isInboundNewUser = false; // Hide the form after creation

        this.messageService.showSuccess(res.response.statusMessage);
        this.selectedUHID = {
          firstName: tempData["contactName"],
          lastName: "",
          gender: "",
          countryCode: tempData["countryCode"],
          phoneNo: tempData["mobileNo"],
          emailId: tempData["emailId"],
          specalityId: tempData["specalityId"],
          isDiagnostics: tempData["isDiagnostics"],
        };
        this.createNewUserForm.reset();
        this.createNewUserForm.patchValue({ countryCode: "" });
        this.UHIDsListTab = false;
        this.UHIDFullDetailsTab = true;
        this.selectedUHID["phoneNo"] = tempData["mobileNo"];
        // Proceed with further actions like updating the call center
        console.log("this.currentMobileNumber", this.currentMobileNumber);
        this.callCenterService.ProceedToUHIDList({
          IsNewUser: true,
          CallerMobileNumber: this.currentMobileNumber,
          CallTypeId: this.callTypeId,
          CallerStatusAutoId: this.callerStatusAutoId,
          CallerId: this.callerId,
          UHIDDetails: this.selectedUHID,
        });
      },
      (error) => {
        this.isSubmitted = false;
        this.messageService.showErrorMessage(
          "Unable to add contact, An error occurred while adding contact."
        );
      }
    );
  }
  CreateNewUser1(formData) {
    //alert("pk");
    debugger;
    this.isSubmitted = true;
    // if (this.createNewUserForm1.invalid) {
    //   this.messageService.showErrorMessage("Please fill in the details..!");
    //   return;
    // }

    let tempData = {
      contactName: this.f1.firstName.value + this.f1.firstName.value,
      //specalityId: Number(this.f.speciality.value),
      emailId: this.f1.email.value,
      CountryCode: this.f1.countryCode.value,
      mobileNo: this.f1.mobileNo.value + "",
      specalityId: Number(this.f1.speciality.value),

      //IsActive:localStorage.getItem("IsActive") == "true" ? true : false,
      // IsActive: true,
      //let currentUser: any = JSON.parse(localStorage.getItem("LOGGED_USER_INFO"));

      // RoleId: currentUser.roleId,
      // Gender:  this.f1.gender.value
      isFrom: 1,
      callLogId: 0,
    };

    this.contactsService.createContact(tempData).subscribe(
      (res) => {
        // alert('km');
        debugger;
        this.isInboundNewUser1 = false; // Hide the form after creation

        this.messageService.showSuccess(res.response.statusMessage);
        this.UHIDsListTab = true;
        this.createNewUserForm1.reset();
        this.selectedUHID = {
          firstName: tempData["contactName"],
          lastName: "",
          //gender: "",
          countryCode: tempData["countryCode"],
          phoneNo: tempData["mobileNo"],
          emailId: tempData["emailId"],
          //specalityId: tempData["specalityId"],
          isDiagnostics: tempData["isDiagnostics"],
        };
        this.createNewUserForm.reset();
        this.isInboundNewUser1 = false;
        this.createNewUserForm.patchValue({ countryCode: "" });
        this.UHIDsListTab = false;
        this.UHIDFullDetailsTab = true;
        this.selectedUHID["phoneNo"] = tempData["mobileNo"];
        // Proceed with further actions like updating the call center
        this.callCenterService.ProceedToUHIDList({
          IsNewUser: true,
          CallerMobileNumber: this.currentMobileNumber,
          CallTypeId: this.callTypeId,
          CallerStatusAutoId: this.callerStatusAutoId,
          CallerId: this.callerId,
          UHIDDetails: this.selectedUHID,
        });
      },
      (error) => {
        this.isSubmitted = false;
        this.messageService.showErrorMessage(
          "Unable to add contact, An error occurred while adding contact."
        );
      }
    );
  }

  specialityData: Speciality[];
  specialityFilterData: any[];
  getAllSpecialities() {
    this.commonService.getAllSpecialities().subscribe(
      (res: any) => {
        if (res.response.length > 0) {
          let specialityFilterData = [];
          this.specialityData = res.response;
          let temp = {
            label: "All",
            value: -1,
          };
          specialityFilterData.push(temp);
          res.response.forEach(function (arrayItem) {
            let temp = {
              label: arrayItem.specalityName,
              value: arrayItem.specalityId,
            };
            specialityFilterData.push(temp);
          });
          this.specialityFilterData = specialityFilterData;
        }
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve speciality data from server "
        );
      }
    );
  }

  filterCountryCode = "-1";
  countryCodes: any[] = [];
  filterCountryCodesInTable: any[] = [];
  getAllCountryCodes() {
    this.commonService.getCountryCodes().subscribe((res: any) => {
      for (let key in res) {
        if (res[key].calling_code == "91") {
          this.createNewUserForm.patchValue({
            countryCode: (res[key].calling_code = "+" + res[key].calling_code),
          });
        }
        this.countryCodes.push(res[key]);
      }
    });
  }

  //neet to remove after integratig dailer api.
  makeCallerId(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  UHIDListOnSearch: any = [];
  isUHIDLoading: boolean = false;
  UHIDListOnSearch1: boolean;
  searchPatientsOnPhoneNo() {
    this.isDefault = false;
    //var number1 = this.currentMobileNumber;
    //if(number1){
    if (this.searchInputOnPhoneNo) {
      this.isUHIDLoading = true;
      debugger;
      let temp = {
        mobile: this.searchInputOnPhoneNo,
        email: this.currentEmailId,
      };
      this.UHIDListOnSearch = [];
      this.askApolloService.getUHIDonMobileorEmail(temp).subscribe(
        (res: any) => {
          if (res.response.length > 0) {
            this.UHIDListOnSearch = res.response;
            this.UHIDListOnSearch1 = false;
            this.createNewUserMessage = ""; // Clear the message if users are found
            this.isDefault = true;
            this.isInboundNewUser1 = false;
          } else {
            this.searchInputOnPhoneNo = ""; // Clear the search input
            this.UHIDListOnSearch = [];
            //this.UHIDListOnSearch1=true;
            this.isInboundNewUser1 = true;

            this.createNewUserMessage =
              "No user found, please create a new user"; // Show message if no user found
          }
          this.isUHIDLoading = false;
        },
        (error) => {
          this.isUHIDLoading = false;
          this.messageService.showErrorMessage(
            "Unable to retrieve UHIDs data from server"
          );
        }
      );
    }
  }

  // Show the "Create New User" form
  openCreateNewUserForm() {
    // alert("kk");
    //isNew:true;
    this.createNewUserMessage = ""; // Show message if no user found
    this.UHIDListOnSearch1 = false;
    //this.UHIDsListTab=false;
    this.isInboundNewUser = true; // Show the form
    this.isDefault = true;
  }

  // Show the "Create New User" form
  openCreateNewUserForm1() {
    // alert("kk");
    //isNew:true;
    this.createNewUserMessage = ""; // Show message if no user found
    this.UHIDListOnSearch1 = false;
    //this.UHIDsListTab=false;
    this.isInboundNewUser1 = true; // Show the form
    this.isDefault = true;
  }
  isWindowFullMaximized: boolean = false;
  isWindowMaximized: boolean = false;
  __modalCustomClass = { width: "27vw" };
  minimaxButtonShow: boolean = false;
  minimizableWindow() {
    this.isWindowMaximized = false;
    this.minimaxButtonShow = !this.minimaxButtonShow;
    this.isWindowFullMaximized = !this.isWindowFullMaximized;
    this.__modalCustomClass = { width: "25vw" };
  }
  maximizableWindow() {
    this.isWindowFullMaximized = false;
    this.minimaxButtonShow = !this.minimaxButtonShow;
    this.isWindowMaximized = !this.isWindowFullMaximized;
    this.__modalCustomClass = { width: "50vw" };
  }

  isMinimized: boolean = true;
  popupStyle = { width: "26vw", height: "75vh" };

  toggleMinimize() {
    this.isMinimized = true;
    this.popupStyle = { width: "26vw", height: "75vh" };
    this.checkScreenSize(); // Ensure `isCompactView` updates when minimized
  }

  toggleMaximize() {
    this.isMinimized = false;
    this.popupStyle = { width: "70vw", height: "95vh" };
    this.isCompactView = false; // Directly show radio buttons in maximized mode
  }

  validateBeforeClose() {
    debugger;
    if (!this.selectedUser) {
      const confirmClose = confirm(
        "No user selected. Do you really want to close?"
      );
      if (!confirmClose) {
        this.display = true; // Prevent modal from closing
        return;
      }
    }
    this.UHIDListOnSearch = [];
    this.searchInputOnPhoneNo = "";
    this.display = false; // Allow modal to close
  }
}
